import React, { useEffect } from "react";
import { usePostFormModalStore } from "../GroupDetailsPage/Stores/PostFormModalStore";
import {
    POST_SOURCE_TYPE,
    POST_FORM_CONTENT_INPUT,
} from "../../Components/Post/PostForm/PostFormModal.types";
import {
    POST_LIST_TYPES,
    PostComponentOptionsType,
    PostType,
} from "../../Components/Post/Post.types";
import { PromoPostsContainer } from "./PostsPromoListFacade.styles";
import { usePostComponentFactory } from "@infrastructure/Hooks/Post/usePostComponentFactory";
import { publish } from "@infrastructure/Events/EventBus";
import { POST_OPTIONS_CLICK } from "../../Components/Post/PostForm/events";
import { PostDetailsPageActions } from "../../Components/Modals/PostDetailsModal/PostDetailsModal";
import { usePostDetailsNavigationActions } from "@infrastructure/Hooks/usePostDetailsNavigationActions";
import { usePostCardClickHandler } from "../GroupDetailsPage/Hooks/usePostCardClickHandler";
import { SERVICE_MODALS_OPTIONS_STATES } from "../../Components/Modals/ServiceFunctionsModal.types";
import { useHiddenPromoPostsStore } from "./useHiddenPromoPostsStore";

export function PostsPromoListFacade({ posts }: { posts: PostType[] }) {
    const onPostCardClick = usePostCardClickHandler(true);

    const { setIsPostFormModalOpen } = usePostFormModalStore();

    function openPostFormHandler(sourceType?: POST_SOURCE_TYPE) {
        setIsPostFormModalOpen(
            true,
            POST_FORM_CONTENT_INPUT.DEFAULT,
            sourceType,
        );
    }

    useEffect(() => {
        return () => {
            setIsPostFormModalOpen(false);
        };
    }, []);

    const { factory } = usePostComponentFactory();

    const { navigateToPostWithAction } = usePostDetailsNavigationActions();

    const { hidePost } = useHiddenPromoPostsStore();

    function commentButtonClicked(
        e: React.MouseEvent<HTMLElement>,
        postId: number,
    ) {
        e.stopPropagation();
        navigateToPostWithAction(postId, PostDetailsPageActions.WRITE_COMMENT);
    }

    return (
        <>
            <PromoPostsContainer>
                {posts.map((post: PostType) => {
                    const postOptions: PostComponentOptionsType = {
                        id: post.id,
                        listType: POST_LIST_TYPES.PROMO,
                        data: post,
                        showGroupName: false,
                        closeButtonCallback: () => hidePost(post.id),
                        postActions: {
                            onAvatarClick: () => {},
                            onCommentButtonClick: commentButtonClicked,
                            onCardContentClickHandler: onPostCardClick,
                            isInsidePostDetails: false,
                            openPostFormHandler,
                            showCommentTeaser: false,
                            // some properties are set to empty until same thing could be done with one event
                            setIsPostOptionsModalOpen: () => {},
                            setModalCurrentAction: () => {},
                            setSelectedPost: (post) =>
                                publish({
                                    name: POST_OPTIONS_CLICK,
                                    post,
                                    modalState:
                                        SERVICE_MODALS_OPTIONS_STATES.POST_STARTING_OPTIONS,
                                }),
                        },
                    };
                    const PostComponent = factory(post);
                    return <PostComponent key={post.id} {...postOptions} />;
                })}
            </PromoPostsContainer>
        </>
    );
}
